import { Ability } from '@casl/ability'
import { initialAbility } from './config'
import { getItem } from '@/@core/utils/storage-utils'

export const canNavigate = to => to.matched.some(route => {
  const userData = JSON.parse(getItem('userData'))
  const existingAbility = userData ? userData.ability : null

  const ability = new Ability(existingAbility || initialAbility)
  return ability.can(route.meta.action || 'read', route.meta.resource)
})
export const _ = undefined
